<section class="auth_sc">
  <div class="auth_flx gap_m">
    <div class="auth_lft">
      <figure class="logo" (click)="loginRoute()">
        <img [src]="webLogo ?? assetsConst.mainLogo" alt="show logo" />

        <div class="form_group" (click)="$event.stopPropagation()">
          <mat-form-field appearance="fill">
            <mat-select [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange($event)" class="form_control">
              <mat-option [value]="'en'">English</mat-option>
              <mat-option [value]="'ar'">العربية</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </figure>

      <router-outlet />
    </div>
    <mindbase-auth-right class="auth_right" />
  </div>
</section>
